<template>
  <div class="no-data">
    <img src="~@/assets/images/not-found.png" alt="">
    <div>{{ $t('txt.noData') }}</div>
  </div>
</template>

<script>
export default {
  props: {
  }
}
</script>

<style lang="stylus" scoped>
.no-data {
  text-align: center;
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translateX(-50%) translateY(-50%);
  img {
    width: 60px;
    height: 54px;
    margin-bottom: 20px;
  }
  div {
    font-size: 16px;
    font-weight: bold;
    line-height: 18px;
    color: rgba(0, 0, 0, 0.4);
  }
}
</style>



// WEBPACK FOOTER //
// src/components/base/baseNoData/index.vue